export default __webpack_public_path__ + "static/media/tv.803c23aa.jpg";